import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicCheckbox, BaasicButton } from 'core/components';
import { toDate } from 'core/utils';

function FacilityOrderTemplateValidationModalTemplate({ facilityOrderTemplateValidationModalViewStore }) {
    const {
        items,
        onChange,
        updateResource
    } = facilityOrderTemplateValidationModalViewStore;

    const validations = items.map(item => {
        return(<tr key={item.id}>
            <td className="wrap">
                {item.notes}
            </td>
            <td className="type--right">
                <BasicCheckbox id={item.id} checked={item.isResolved} onChange={() => onChange(item)} />
            </td>
            <td>
                {item.coreUser && item.coreUser.displayName}
            </td>
            <td>
                {toDate(item.dateResolved,true)}
            </td>
        </tr>)
    })

    return (
        <section>
            <div className="row">
                <div className="col col-med-11 u-mar--bottom--tny">
                    <h4>Validations list</h4>
                </div>
            </div>    
            <div className="row">
                <div className="col col-lrg-12 u-mar--bottom--tny">                               
                    <table className="table--preview u-mar--bottom--med">
                        <thead>
                            <tr>
                                <th className="type--left">To Confirm</th>
                                <th className="type--left"></th>
                                <th className="type--left">Resolved by user</th>
                                <th className="type--left">Resolved</th>
                            </tr>
                        </thead>
                        <tbody>{validations}</tbody>
                    </table>
                </div>
            </div>
            
            <BaasicButton
                className="btn btn--base btn--primary u-mar--left--auto"
                label='Update'
                onClick={() => updateResource()}>
            </BaasicButton> 
        </section> 
    );
    
}

FacilityOrderTemplateValidationModalTemplate.propTypes = {
    facilityOrderTemplateValidationModalViewStore: PropTypes.object
};

export default defaultTemplate(FacilityOrderTemplateValidationModalTemplate);
